import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject, map } from 'rxjs';
import { environment } from 'src/environments/environment.development';
import { LoginData, User } from '../models/user';
import { Router } from '@angular/router';
// import { JwtModule, JwtHelperService } from "@auth0/angular-jwt";
import { jwtDecode } from 'jwt-decode'
import {JwtHelperService} from '@auth0/angular-jwt';
import { HelperService } from '../helpers/helper.service';
import { ToastrService } from 'ngx-toastr';


const httpOptions = {
  headers: new HttpHeaders({
    // "mimeType": "multipart/form-data",
    // "processData": 'false',
    // "contentType": 'false'
  })
}

interface DecodedToken {
  exp: number;
  // Add other claims as needed
}

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  baseUrl = environment.basicUrl
  version = environment.version
  private currentUserSource = new ReplaySubject<User>(1)
  currentUser$ = this.currentUserSource.asObservable()
  public userExp: any = new BehaviorSubject(false);

  constructor(
    private http: HttpClient,
    public router: Router,
    private _helper: HelperService,
    private jwtHelper: JwtHelperService,
    public toastr: ToastrService
    ) { 
    this.userExp.next(this.isTokenExpired());
  }

  login(model: any, loginOrRegister: string) {
    console.log(`${this.baseUrl}/${this.version}/login`);
    
    return this.http.post(`${this.baseUrl}/${this.version}/${loginOrRegister}`, model).pipe(
      map((response: any) => {
        const user = response
        // if (Number(user.user.accept_terms_flag) == 1) {
          if (user && user.student) {
            localStorage.setItem('user', JSON.stringify(user))
            this.currentUserSource.next(user)
            this.router.navigate(['/dashboard/default'])
          } else {
            this.toastr.error('ليس لديك صلاحية للدخول')
          }
        // } else {
        //   localStorage.setItem('user', JSON.stringify(user))
        //   this.router.navigate(['/terms-and-conditions/from-login'])
        // }
      })
    )
  }

  setCurrentUser(user: User) {
    this.currentUserSource.next(user)
  }

  isTokenExpired() {
    const token = JSON.parse(localStorage.getItem('user')!)?.access_token;
    return this.jwtHelper.isTokenExpired(token)
  }

  // isTokenExpired(token: string): boolean {
  //   const decodedToken = jwtDecode(token) as DecodedToken;
  //   const expirationDate = decodedToken.exp * 1000; // Convert seconds to milliseconds
  //   const currentDate = new Date().getTime();

  //   console.log(decodedToken, 'decodedToken');
  //   console.log(expirationDate, 'expired date');
  //   console.log(currentDate, 'currentDate');
    
  
  //   return expirationDate < currentDate;
  // }

  Logout() {
    localStorage.removeItem('user')
    this.currentUserSource.next(null!)
    this.router.navigate(['/auth/login']);
  }

  resetCode(phone: any) {
    let model = {
      phone
    }
    return this._helper.createFormData(`send_code`, model)
  }

  resetPassword(model: any) {
    return this._helper.createFormData(`reset_password`, model)
  }

  updateParent(model: any) {
    return this._helper.createFormData(`update_parent`, model)
  }

  verifyCode(model: any) {
    return this._helper.createFormData(`verify_code`, model)
  }
}
